function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIllustrationWrapper } from '../../components/atoms/Illustration/withIllustrationWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IllustrationPersonWithFlag = function IllustrationPersonWithFlag(props, ref) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "73",
    height: "60",
    viewBox: "0 0 73 60",
    fill: "none",
    stroke: "none",
    ref: ref
  }, props), ___EmotionJSX("g", {
    clipPath: "url(#clip0_1357_5001)"
  }, ___EmotionJSX("path", {
    d: "M29.8268 0.346344C13.3536 0.346344 -2.4176e-05 13.7003 -2.4176e-05 30.1732C-0.0104925 36.8197 2.20914 43.2776 6.30361 48.5132C6.45275 46.3228 6.71347 44.2546 7.15245 42.7955C8.63853 37.858 9.62878 35.6722 12.1658 33.0095C14.2105 30.8623 18.1224 29.2615 18.267 29.1668C18.2866 29.1534 18.3158 29.217 18.3519 29.3422C18.6944 29.1647 18.993 28.9685 19.1758 28.6295C19.5113 28.0067 19.751 26.7733 20.0383 26.7733C20.3257 26.7733 24.3109 26.7252 24.4278 26.7733C24.5447 26.8213 24.5924 28.1155 24.832 28.5467C24.9626 28.7815 25.4482 29.0306 25.8848 29.2706C25.8995 29.2651 25.9155 29.2634 25.9311 29.2657C26.2795 29.3068 32.406 30.1781 35.8511 29.9423C40.8691 29.6012 42.7064 27.9972 48.7854 28.2443C48.7854 28.2443 49.4711 29.8258 48.837 32.7137C48.7191 33.2517 43.5664 36.1943 39.5697 37.1116C35.6683 38.0068 33.405 38.6524 32.148 39.9108C31.3606 40.6992 31.8757 45.7252 31.7971 49.9231C31.7347 53.1865 31.2781 58.8711 31.188 59.9691C47.0288 59.2575 59.6533 46.1902 59.6533 30.1735C59.6536 13.7003 46.3 0.346344 29.8268 0.346344Z",
    fill: "#C1E9E7"
  }), ___EmotionJSX("path", {
    d: "M52.1686 2.90514C53.1297 2.60827 56.7198 1.04535 61.325 0.45302C66.6483 -0.232646 72.0866 0.0638682 72.2771 0.0638682C72.6322 0.0638682 71.3037 3.81573 71.1542 5.44252C70.7861 9.43546 71.7574 12.2027 71.1223 12.1392C70.1029 12.0371 66.5254 11.6097 61.7953 12.3911C57.3798 13.1207 52.5816 15.4693 52.1693 14.412C51.8657 13.6358 52.1686 2.90514 52.1686 2.90514Z",
    fill: "url(#paint0_linear_1357_5001)"
  }), ___EmotionJSX("path", {
    d: "M52.7594 27.6021C52.8545 15.2854 52.9412 5.31409 52.8794 3.67467C52.7489 0.213706 51.579 0.820419 51.6295 3.67467C51.7485 10.4226 51.7681 18.26 51.7274 27.7905",
    fill: "url(#paint1_linear_1357_5001)"
  }), ___EmotionJSX("path", {
    d: "M20.1928 25.4546C20.1928 26.2694 20.2535 27.8863 19.918 28.7969C19.5825 29.7075 24.5678 29.3724 24.424 28.9408C24.2801 28.5092 23.8976 25.8251 23.9446 25.4893C23.9916 25.1535 20.1928 25.4546 20.1928 25.4546Z",
    fill: "url(#paint2_linear_1357_5001)"
  }), ___EmotionJSX("path", {
    d: "M16.7441 17.8877C16.7048 18.3312 16.6985 19.2934 16.6985 19.2934C15.5366 19.3506 15.4229 20.0082 15.4152 20.6398C15.4008 21.8003 15.8422 22.8652 17.1623 23.2014C17.3434 23.2474 17.9421 25.8174 21.9024 25.6616C24.4036 25.5612 25.8879 25.2258 26.7897 22.4414C26.8754 22.1764 28.8601 22.062 28.2825 19.645C28.0277 18.579 27.1112 19.2337 27.1182 19.1011C27.1385 18.7249 27.094 18.5046 27.0512 18.1312C26.8596 16.4535 26.4662 15.7451 25.8528 14.9194C25.1338 13.9509 23.3614 13.6252 21.6346 13.6252C19.572 13.6252 17.0515 14.4014 16.7441 17.8877Z",
    fill: "url(#paint3_linear_1357_5001)"
  }), ___EmotionJSX("path", {
    d: "M27.1172 19.1011C26.6673 17.5796 26.6396 17.0286 26.4269 16.3907C26.235 15.8152 25.5988 15.4317 25.4072 15.3359C25.2156 15.2401 25.0847 15.244 24.5924 15.205C24.3468 15.1857 23.5457 15.3454 23.0674 15.2882C22.2673 15.192 21.7052 14.8215 20.6265 14.9176C19.9514 14.9776 19.6068 15.3359 19.1755 15.4791C18.7442 15.6222 18.0249 15.7798 17.5936 16.2591C17.0543 16.8581 17.0195 19.2864 16.6985 19.2927C16.0609 19.305 15.7103 19.6436 15.7103 19.6436C15.5531 19.5148 14.8134 18.4017 14.8611 17.9705C14.9089 17.5392 15.1489 17.0581 15.0531 16.676C14.9573 16.2939 14.8074 16.1967 14.858 15.9089C14.9085 15.6212 14.8611 14.3751 15.244 14.0396C15.6268 13.7042 16.1893 13.7168 16.3813 13.4782C16.5732 13.2396 16.5995 12.929 17.1136 12.7462C17.3438 12.6645 17.9284 12.6985 18.1203 12.5546C18.3123 12.4108 18.6604 12.1013 19.092 12.0532C19.5236 12.0051 20.1594 11.9795 20.6388 11.9314C21.1181 11.8833 21.8592 11.7398 22.866 11.8356C23.8727 11.9314 25.071 11.8963 25.5504 12.2321C26.0297 12.568 26.0416 13.3694 26.2824 13.6572C26.5231 13.9449 26.6178 14.4242 26.8575 15.1432C27.0972 15.8622 27.3656 17.2522 27.241 18.0207C27.1165 18.7891 27.1172 19.1011 27.1172 19.1011Z",
    fill: "url(#paint4_linear_1357_5001)"
  }), ___EmotionJSX("path", {
    d: "M47.6507 29.0306C48.7967 28.9373 49.8357 28.7176 50.1519 28.5158C50.4681 28.3141 50.9463 27.514 51.445 27.3115C52.0598 27.0617 52.7591 26.9863 52.9539 26.9859C53.4451 26.9859 52.9791 27.6344 53.0984 27.6221C53.2177 27.6098 53.4293 27.5312 53.9308 27.7196C54.4322 27.9081 54.1883 29.3156 54.2606 29.6987C54.3947 30.4072 54.4733 31.4592 53.9206 31.7982C53.3679 32.1372 53.0553 32.0708 52.1363 32.1386C51.3001 32.2 50.7733 31.8442 50.494 31.7045C50.2147 31.5648 48.449 32.1824 47.8973 32.2154C47.3457 32.2484 47.4496 29.0471 47.6507 29.0306Z",
    fill: "url(#paint5_linear_1357_5001)"
  }), ___EmotionJSX("path", {
    d: "M24.8321 28.5464C24.5924 28.1151 24.5447 26.8206 24.4278 26.7729C24.311 26.7252 20.3261 26.7729 20.0384 26.7729C19.7506 26.7729 19.512 28.0063 19.1759 28.6292C18.993 28.9682 18.6944 29.1643 18.3519 29.3419C18.5786 30.1328 19.0755 33.4064 19.1997 35.9287C19.3436 38.8528 19.3913 42.4481 19.2955 44.6532C19.2183 46.426 19.5443 54.9519 19.6748 58.2269C21.7534 58.9798 23.9096 59.4977 26.1034 59.7709C25.9237 57.8967 25.1763 49.5624 25.4184 42.8924C25.4848 41.0698 25.7192 37.0793 26.0894 33.4141C26.3511 30.8266 25.6434 29.3714 25.8865 29.2703C25.4483 29.0303 24.9626 28.7808 24.8321 28.5464Z",
    fill: "url(#paint6_linear_1357_5001)"
  }), ___EmotionJSX("path", {
    d: "M24.8321 28.5464C24.5924 28.1151 24.5447 26.8206 24.4278 26.7729C24.311 26.7252 20.3261 26.7729 20.0384 26.7729C19.7506 26.7729 19.512 28.0063 19.1759 28.6292C18.993 28.9682 18.6944 29.1643 18.3519 29.3419C18.5786 30.1328 19.0755 33.4064 19.1997 35.9287C19.3436 38.8528 19.3913 42.4481 19.2955 44.6532C19.2183 46.426 19.5443 54.9519 19.6748 58.2269C21.7534 58.9798 23.9096 59.4977 26.1034 59.7709C25.9237 57.8967 25.1763 49.5624 25.4184 42.8924C25.4848 41.0698 25.7192 37.0793 26.0894 33.4141C26.3511 30.8266 25.6434 29.3714 25.8865 29.2703C25.4483 29.0303 24.9626 28.7808 24.8321 28.5464Z",
    fill: "url(#paint7_linear_1357_5001)"
  }), ___EmotionJSX("path", {
    d: "M32.1498 39.9104C33.4067 38.6521 35.6701 38.0064 39.5714 37.1112C43.5682 36.194 48.7209 33.2513 48.8388 32.7134C49.4729 29.8254 48.7872 28.2439 48.7872 28.2439C42.7081 27.9983 40.8719 29.6008 35.8529 29.9419C32.4077 30.1763 26.2813 29.3064 25.9328 29.2654C25.5665 29.2226 26.3648 30.6918 26.0893 33.4141C25.7191 37.0793 25.4847 41.0698 25.4184 42.8924C25.1763 49.5596 25.9237 57.8953 26.1034 59.7709C27.3386 59.9246 28.5821 60.0016 29.8268 60.0014C30.283 60.0014 30.7368 59.991 31.1883 59.9702C31.2785 58.8725 31.735 53.1879 31.7975 49.9241C31.8778 45.7249 31.3624 40.6989 32.1498 39.9104Z",
    fill: "url(#paint8_linear_1357_5001)"
  }), ___EmotionJSX("path", {
    d: "M32.1498 39.9104C33.4067 38.6521 35.6701 38.0064 39.5714 37.1112C43.5682 36.194 48.7209 33.2513 48.8388 32.7134C49.4729 29.8254 48.7872 28.2439 48.7872 28.2439C42.7081 27.9983 40.8719 29.6008 35.8529 29.9419C32.4077 30.1763 26.2813 29.3064 25.9328 29.2654C25.5665 29.2226 26.3648 30.6918 26.0893 33.4141C25.7191 37.0793 25.4847 41.0698 25.4184 42.8924C25.1763 49.5596 25.9237 57.8953 26.1034 59.7709C27.3386 59.9246 28.5821 60.0016 29.8268 60.0014C30.283 60.0014 30.7368 59.991 31.1883 59.9702C31.2785 58.8725 31.735 53.1879 31.7975 49.9241C31.8778 45.7249 31.3624 40.6989 32.1498 39.9104Z",
    fill: "url(#paint9_linear_1357_5001)"
  }), ___EmotionJSX("path", {
    d: "M19.2955 44.6532C19.3913 42.4482 19.3436 38.8528 19.1997 35.9287C19.0558 33.0046 18.4105 29.0699 18.267 29.1668C18.1235 29.2636 14.2106 30.8634 12.1658 33.0106C9.62881 35.675 8.63856 37.859 7.15249 42.7966C6.71351 44.2557 6.45278 46.3239 6.30365 48.5142C9.75921 52.9445 14.3934 56.3111 19.6748 58.2279C19.5443 54.9519 19.2183 46.426 19.2955 44.6532Z",
    fill: "url(#paint10_linear_1357_5001)"
  }), ___EmotionJSX("path", {
    d: "M19.2955 44.6532C19.3913 42.4482 19.3436 38.8528 19.1997 35.9287C19.0558 33.0046 18.4105 29.0699 18.267 29.1668C18.1235 29.2636 14.2106 30.8634 12.1658 33.0106C9.62881 35.675 8.63856 37.859 7.15249 42.7966C6.71351 44.2557 6.45278 46.3239 6.30365 48.5142C9.75921 52.9445 14.3934 56.3111 19.6748 58.2279C19.5443 54.9519 19.2183 46.426 19.2955 44.6532Z",
    fill: "url(#paint11_linear_1357_5001)"
  }), ___EmotionJSX("path", {
    d: "M52.3671 28.6611C52.3556 30.1441 51.9983 31.4333 52.3619 31.9035C52.5651 32.1656 52.7335 32.0189 52.7331 32.1042C52.7216 35.9392 52.5482 37.7538 52.603 38.4966C52.7265 40.1697 51.2446 41.0379 51.3667 37.8446C51.5285 33.5955 51.5285 35.448 51.7274 28.851L52.3671 28.6611Z",
    fill: "url(#paint12_linear_1357_5001)"
  })), ___EmotionJSX("defs", null, ___EmotionJSX("linearGradient", {
    id: "paint0_linear_1357_5001",
    x1: "62.1855",
    y1: "3.67434e-06",
    x2: "62.1855",
    y2: "14.6811",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    offset: "0.01",
    stopColor: "#69C1BD"
  }), ___EmotionJSX("stop", {
    offset: "0.31",
    stopColor: "#61BFBA"
  }), ___EmotionJSX("stop", {
    offset: "0.77",
    stopColor: "#4BB9B0"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#3DB5AA"
  })), ___EmotionJSX("linearGradient", {
    id: "paint1_linear_1357_5001",
    x1: "52.0053",
    y1: "17.9901",
    x2: "53.1345",
    y2: "2.40686",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#F2A7B6"
  }), ___EmotionJSX("stop", {
    offset: "0.05",
    stopColor: "#F2A3B2"
  }), ___EmotionJSX("stop", {
    offset: "0.36",
    stopColor: "#EF909F"
  }), ___EmotionJSX("stop", {
    offset: "0.68",
    stopColor: "#ED8494"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#ED8090"
  })), ___EmotionJSX("linearGradient", {
    id: "paint2_linear_1357_5001",
    x1: "22.1652",
    y1: "25.3307",
    x2: "22.1652",
    y2: "29.3749",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E7B2A2"
  }), ___EmotionJSX("stop", {
    offset: "0.24",
    stopColor: "#F0BFAE"
  }), ___EmotionJSX("stop", {
    offset: "0.56",
    stopColor: "#F7C8B7"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#F9CBBA"
  })), ___EmotionJSX("linearGradient", {
    id: "paint3_linear_1357_5001",
    x1: "17.5013",
    y1: "24.026",
    x2: "26.2437",
    y2: "15.2836",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E7B2A2"
  }), ___EmotionJSX("stop", {
    offset: "0.04",
    stopColor: "#EAB6A6"
  }), ___EmotionJSX("stop", {
    offset: "0.2",
    stopColor: "#F3C2B1"
  }), ___EmotionJSX("stop", {
    offset: "0.43",
    stopColor: "#F8C9B8"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#F9CBBA"
  })), ___EmotionJSX("linearGradient", {
    id: "paint4_linear_1357_5001",
    x1: "7255.86",
    y1: "3854.53",
    x2: "8963.34",
    y2: "6560.45",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    offset: "0.01",
    stopColor: "#69C1BD"
  }), ___EmotionJSX("stop", {
    offset: "0.31",
    stopColor: "#61BFBA"
  }), ___EmotionJSX("stop", {
    offset: "0.77",
    stopColor: "#4BB9B0"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#3DB5AA"
  })), ___EmotionJSX("linearGradient", {
    id: "paint5_linear_1357_5001",
    x1: "50.9929",
    y1: "32.1874",
    x2: "50.7689",
    y2: "27.0789",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#E7B2A2"
  }), ___EmotionJSX("stop", {
    offset: "0.13",
    stopColor: "#EBB7A7"
  }), ___EmotionJSX("stop", {
    offset: "0.6",
    stopColor: "#F5C6B5"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#F9CBBA"
  })), ___EmotionJSX("linearGradient", {
    id: "paint6_linear_1357_5001",
    x1: "5730.29",
    y1: "4969.06",
    x2: "5730.29",
    y2: "61072.2",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D4E8E7"
  }), ___EmotionJSX("stop", {
    offset: "0.52",
    stopColor: "#D1E4E5"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#CAD9E0"
  })), ___EmotionJSX("linearGradient", {
    id: "paint7_linear_1357_5001",
    x1: "5730.29",
    y1: "29815.6",
    x2: "5730.29",
    y2: "61229.7",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#F2A7B6"
  }), ___EmotionJSX("stop", {
    offset: "0.05",
    stopColor: "#F2A3B2"
  }), ___EmotionJSX("stop", {
    offset: "0.36",
    stopColor: "#EF909F"
  }), ___EmotionJSX("stop", {
    offset: "0.68",
    stopColor: "#ED8494"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#ED8090"
  })), ___EmotionJSX("linearGradient", {
    id: "paint8_linear_1357_5001",
    x1: "27555.6",
    y1: "4785.5",
    x2: "27555.6",
    y2: "58816.6",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D4E8E7"
  }), ___EmotionJSX("stop", {
    offset: "0.52",
    stopColor: "#D1E4E5"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#CAD9E0"
  })), ___EmotionJSX("linearGradient", {
    id: "paint9_linear_1357_5001",
    x1: "42.8699",
    y1: "53.4023",
    x2: "28.1744",
    y2: "27.9488",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#4FB1C9"
  }), ___EmotionJSX("stop", {
    offset: "0.57",
    stopColor: "#3DA4BF"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#2C99B5"
  })), ___EmotionJSX("linearGradient", {
    id: "paint10_linear_1357_5001",
    x1: "6273.52",
    y1: "4379.3",
    x2: "6273.52",
    y2: "53760.4",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D4E8E7"
  }), ___EmotionJSX("stop", {
    offset: "0.52",
    stopColor: "#D1E4E5"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#CAD9E0"
  })), ___EmotionJSX("linearGradient", {
    id: "paint11_linear_1357_5001",
    x1: "3656.64",
    y1: "40282.5",
    x2: "8841.05",
    y2: "40282.5",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#4FB1C9"
  }), ___EmotionJSX("stop", {
    offset: "0.57",
    stopColor: "#3DA4BF"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#2C99B5"
  })), ___EmotionJSX("linearGradient", {
    id: "paint12_linear_1357_5001",
    x1: "2255.46",
    y1: "9504.72",
    x2: "3156",
    y2: "7998.45",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#F2A7B6"
  }), ___EmotionJSX("stop", {
    offset: "0.05",
    stopColor: "#F2A3B2"
  }), ___EmotionJSX("stop", {
    offset: "0.36",
    stopColor: "#EF909F"
  }), ___EmotionJSX("stop", {
    offset: "0.68",
    stopColor: "#ED8494"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#ED8090"
  })), ___EmotionJSX("clipPath", {
    id: "clip0_1357_5001"
  }, ___EmotionJSX("rect", {
    width: "72.3371",
    height: "60",
    fill: "white"
  }))));
};

export default withIllustrationWrapper( /*#__PURE__*/forwardRef(IllustrationPersonWithFlag));
//# sourceMappingURL=IllustrationPersonWithFlag.js.map